import React, { useState } from 'react';
import InputForm from './components/InputForm';
import AuditDeck from './components/AuditDeck';
import Loading from './components/Loading';

function App() {
  const [auditData, setAuditData] = useState(null);
  const [leadId, setLeadId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAuditGenerated = (data, id) => {
    setAuditData(data);
    setLeadId(id);
    setLoading(false);
    setError(null);
  };

  const handleLoading = () => {
    setLoading(true);
    setError(null);
  };

  const handleError = (err) => {
    setError(err);
    setLoading(false);
  };

  const handleReset = () => {
    setAuditData(null);
    setLeadId(null);
    setError(null);
  };

  return (
    <div className="min-h-screen">
      {/* Header */}
      <header className="p-6 flex justify-between items-center">
        <div>
          <div className="text-amber-400 font-bold text-2xl tracking-widest">HOWL</div>
          <div className="text-amber-400/70 text-xs tracking-wider">Marketing & Business Development</div>
        </div>
        {auditData && (
          <button
            onClick={handleReset}
            className="px-4 py-2 bg-slate-800 text-white rounded-lg hover:bg-slate-700 transition"
          >
            ← New Audit
          </button>
        )}
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 pb-12">
        {loading ? (
          <Loading />
        ) : auditData ? (
          <AuditDeck audit={auditData} leadId={leadId} />
        ) : (
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-5xl font-bold text-white mb-4">
                LinkedIn <span className="text-amber-400">Audit</span>
              </h1>
              <p className="text-slate-300 text-lg">
                Get a personalized profile optimization report to improve your outreach performance
              </p>
            </div>
            
            {error && (
              <div className="mb-6 p-4 bg-red-500/20 border border-red-500 rounded-lg text-red-200">
                {error}
              </div>
            )}
            
            <InputForm 
              onSubmit={handleLoading}
              onSuccess={handleAuditGenerated}
              onError={handleError}
            />
          </div>
        )}
      </main>

      {/* Footer */}
      <footer className="fixed bottom-0 left-0 right-0 p-4 text-center text-slate-500 text-sm">
        Powered by <span className="text-amber-400">HOWL</span> Marketing & Business Development
      </footer>
    </div>
  );
}

export default App;